export const cardContainerStyle = {
  maxWidth: 445,
  border: "1px solid gray",
  // borderRadius: "15px",
  padding: "10px",
  boxShadow: "5px 5px gray, 10px 10px gray, 15px 15px gray, 20px 20px gray",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "5px",
};
